"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var User = function User(_a) {
  var id = _a.id;
  var clipPathId = id ? "Users__clip0__".concat(id) : 'Users__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M5.995 6a6 6 0 1112 0 6 6 0 01-12 0zM23.83 21.825l-2.16-4.335A4.5 4.5 0 0017.636 15H6.356a4.5 4.5 0 00-4.035 2.49L.16 21.825A1.5 1.5 0 001.495 24h21a1.5 1.5 0 001.335-2.175z"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.User = User;